import { Component, EventEmitter, inject, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Auth } from '../../../services/auth';
import { Verification } from '../../../services/verification';
import { Admin } from '../../../services/admin';
import { SuccessDialog } from '../../common-features/success-dialog/success-dialog';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Country } from 'country-state-city';
import { NavStateService } from '../../../services/nav-state.service';
import { User } from '../../../services/user';
import { ViewUploadedFile } from '../../common-features/view-uploaded-file/view-uploaded-file';
import { VerificationPatchService } from '../../../services/verification-patch-service';
import { map, Observable, startWith, Subscription } from 'rxjs';
@Component({
  selector: 'app-verification-form',
  standalone: false,
  templateUrl: './verification-form.html',
  styleUrl: './verification-form.less',
})
export class VerificationForm implements OnInit, OnDestroy {
  verificationForm!: FormGroup;
  private authService = inject(Auth);
  private verificationService = inject(Verification);
  private adminService = inject(Admin);
  private matDialog = inject(MatDialog);
  private router = inject(Router);
  private navState = inject(NavStateService);
  private userService = inject(User);
  @Output() moveToPreviousPage = new EventEmitter<any>();
  @Output() canonSearch = new EventEmitter<any>();
  private transferService = inject(VerificationPatchService);
  private subStream!: Subscription;
  showAuditWarningMessage: boolean = false;
  uploadedFiles: any[] = [];
  verificationData: any;
  currentUrl: string = '';
  user: any;
  uploadedFile: File | null = null;
  isDragOver = false;
  record: any;
  countries = Country.getAllCountries();
  mode: string = 'create';
  userType:string='';
  verificationRecord: any = '';
  selectedRecord: any;
  countryCode:any;
  filteredCountries$!: Observable<any[]>;
  constructor(private fb: FormBuilder) {
    this.authService.user.subscribe((x: any) => this.user = x)

  }

  ngOnInit(): void {
    const inputData = window.history.state;
    this.mode = inputData.mode;
    this.verificationRecord = inputData.record;
    this.userType = inputData.userType;
    this.currentUrl = this.router.url;
    console.log('Actual URL String:', this.currentUrl);
    this.navState.setCurrentTitle(this.mode === 'edit' ? this.user?.role==='admin' ? 'Edit Verification Request' : 'Review Verification Request' : 'Create Verification Request');
    this.navState.setShowBackButton(true);
   
    this.verificationForm = this.fb.group({
      companyName: ['', Validators.required],
      type: [''],
      registeredAddress: ['', Validators.required],
      country: ['', Validators.required],
      website: [''],
      contactName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      contactNos: ['', Validators.required],
      status:[''],
      creditRecommendation: [""],
      assessmentComments: [""],
      riskRating: [""],
      // submittedMedia: [""],
      // cofaceMedia: [""],
      // cofaceDecisionDate: [""],
      // parentId: [""],
      // queuedForAudit: [''],
      // countryCode:[''],

    });

     if (this.mode == 'edit') {
      console.log(this.verificationRecord);
      this.record = this.verificationRecord;
      this.verificationForm.patchValue(this.verificationRecord);
      this.getUploadedDocuments(this.verificationRecord.id);
    }
    this.subStream = this.transferService.activeRecord$.subscribe({
      next: (data: any) => {
        if (data) {
          this.patchRequest(this.record, data);
        }

      }
    });
    this.filteredCountries$ = this.verificationForm.get('country')!.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );
  }

 private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.countries.filter(country => 
      country.name.toLowerCase().includes(filterValue)
    );
  }

  // getVerificationById() {
  //   this.verificationService.getVerificationById(this.id)
  //     .subscribe({
  //       next: (data: any) => {
  //         console.log(data)
         
  //         this.record = data;
  //       }, error: (error: any) => {
  //         console.log(error)
  //       }
  //     })
  // }

  getUploadedDocuments(id: string) {
    this.userService.getMediaFiles("VERIFICATION", id).subscribe({
      next: (data: any) => {
        this.uploadedFiles = data;
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }
  viewMediaFile(row: any) {
    console.log(row);
    let viewFileComponent = this.matDialog.open(ViewUploadedFile, {
      disableClose: true,
      height: '800px',
      width: '800px',
      data: row
    });
    viewFileComponent.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  deleteMedia(id: any) {
    this.userService.deleteMediaById(id).subscribe({
      next: (data: any) => {
        console.log(data);
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }

  onFileSelected(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    if (element.files && element.files.length > 0) {
      this.processFile(element.files[0]);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      this.processFile(event.dataTransfer.files[0]);
    }
  }

  private processFile(file: File): void {
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB

    if (!allowedTypes.includes(file.type)) {
      alert('Invalid file format. Please upload a PDF, JPG, or PNG file.');
      return;
    }

    if (file.size > maxSizeInBytes) {
      alert('File is too large. Maximum size allowed is 10MB.');
      return;
    }
    this.uploadedFile = file;
  }

  uploadFile(verificationId: any) {
    const mediaData = new FormData();
    mediaData.append("file", this.uploadedFile!);
    mediaData.append("entityType", 'VERIFICATION');
    mediaData.append("entityId", verificationId);
    mediaData.append("docType", 'verificationRequest');
    this.adminService
      .uploadProfilePic(mediaData)
      .pipe()
      .subscribe({
        next: (data: any) => {
          console.log(data);
          //success and error messages
          this.showSuccessAndErrorDialog('SUCCESS', 'Request created successfully!', 'success');

        },
        error: (error) => {
          this.showSuccessAndErrorDialog('ERROR', 'Could not create request. Please contact admin.', 'error');
          console.log(error);
        },
      });

    this.uploadedFile = null;

  }

  onCancel(): void {
    this.verificationForm.reset();
    this.uploadedFile = null;
  }

  onSubmit(): void {
    if (this.verificationForm.valid) {

      console.log('Form Submitted successfully:', this.verificationForm.value);

      if (this.mode == 'create') {
        const form = {
          ...this.verificationForm.value,
          requestedByUserId: this.user.id,
          requestedByOrgId: this.user.orgId,
          status: "NEW",
          requestStatus:"NEW", 
          inactive: false,
        }
        console.log('form', form)
        this.verificationService.postVerificationForm(form)
          .subscribe({
            next: (data: any) => {
              console.log(data);
              if (this.uploadedFile) {
                this.uploadFile(data.id)
              } else {
                this.showSuccessAndErrorDialog('SUCCESS', 'Request created successfully!', 'success');
              }

            }, error: (error: any) => {
              console.log(error)
              this.showSuccessAndErrorDialog('ERROR', 'Could not create request. Please contact admin.', 'error');
            }
          })
      } else if (this.mode == 'edit') {
        const form = {
          ...this.verificationForm.value,
          requestedByUserId: this.user.id,
          requestedByOrgId: this.user.orgId,
          inactive: false,
        }
        this.verificationService.updateVerificationForm(form, this.verificationRecord.id, false)
          .subscribe({
            next: (data: any) => {
              console.log(data)
              if (this.uploadedFile) {
                this.uploadFile(data.id)
              } else {
                this.showSuccessAndErrorDialog('SUCCESS', 'Request updated successfully!', 'success');
              }

            }, error: (error: any) => {
              console.log(error);
              this.showSuccessAndErrorDialog('Error', 'Could not update request. Please contact admin.', 'error');
            }
          })
      }

    } else {
      this.verificationForm.markAllAsTouched();
      const firstInvalidInput = Object.keys(this.verificationForm.controls).find(key => this.verificationForm.controls[key].invalid);
      console.log('First invalid field:', firstInvalidInput);
      if (firstInvalidInput) {
        let element = document.getElementById(firstInvalidInput);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      return;
    }
  }

  showSuccessAndErrorDialog(title: any, message: any, icon: any) {
    const dialog = this.matDialog.open(SuccessDialog, {
      disableClose: true,
      width: '500px',
      data: {
        title: title,
        subtitle: message,
        icon: icon
      },
    })
    dialog.afterClosed().subscribe(result => {
      this.moveToVerifcationList();
    })
  }
  moveToVerifcationList() {
    this.moveToPreviousPage.emit();
    // if(this.currentUrl == '/admin/verification-summary'){
    //   this.router.navigate(['/admin/verification-summary'])
    // }else if (this.currentUrl == '/admin/verification-list'){
    //   this.router.navigate(['/admin/verification-list'])
    // }else if (this.currentUrl =='/admin/verification-history'){
    //   this.router.navigate(['/admin/verification-history'])
    // }

  }

  mapCofanetForm() {
    // const isQueued = this.verificationForm.get('queuedForAudit')?.value;
    // this.verificationForm.get('queuedForAudit')?.setValue(true);
    // if (isQueued === true) {
    //   this.showAuditWarningMessage = true;

    // } else {
    this.canonSearch.emit(this.verificationRecord);
    console.log(this.verificationRecord)
    // }

  }

  disableAuditAndProceed(): void {
    this.verificationForm.get('queuedForAudit')?.setValue(false);
    this.showAuditWarningMessage = false;
    this.canonSearch.emit(this.record);
  }


  patchRequest(record: any, result: any) {
    console.log(record);
    console.log(result);
    const form =
    {
      "id": record.id,
      "companyName": record.companyName,
      "registeredAddress": record.registeredAddress,
      "country": record.country,
      "website": record.website,
      "contactName": record.contactName,
      "email": record.email,
      "contactNos": record.contactNos,
      "requestStatus": 'SUCCESS',
      "requestedByUserId": record.requestedByUserId,
      "requestedByOrgId": record.requestedByOrgId,
      "registrationType": record.registrationType,
      "registrationId": record.registrationId,
      "canonId": result.id,
      "inactive": record.inactive,
      "queuedForAudit": record.queuedForAudit,
      "resolved": true
    }


    this.verificationService.patchVerificationRequest(record.id, form)
      .subscribe({
        next: (response: any) => {
          console.log(response);
          this.showSuccessAndErrorDialog('SUCCESS', 'Record mapped successfully!', 'success');
        },
        error: (err: any) => {
          console.log(err);
          this.showSuccessAndErrorDialog('Error', 'Could not map the record. Please contact admin.', 'error');
        }
      })
  }

  ngOnDestroy(): void {
    if (this.subStream) {
      this.subStream.unsubscribe();
    }
  }

    onCountryCodeChange(event?: any) {
    const countryName = event?.target?.value || event;
    const country = this.countries.find(c => c.name === countryName);
    if (country) {
      this.countryCode = country.isoCode.toLowerCase();
    }
  }
}